import React from 'react';
import { Card, Typography, List } from 'antd';
import { CommonIssuesData } from '../../../types/api';

const { Title } = Typography;

interface CommonIssuesResearchProps {
    commonIssues: CommonIssuesData;
}

export const CommonIssuesResearch: React.FC<CommonIssuesResearchProps> = ({ commonIssues }) => {
    const sortedIssues = [...commonIssues.updated_common_issues].sort((a, b) => b.concern_level - a.concern_level);

    return (
        <Card bordered={false} style={{ borderRadius: 12, marginBottom: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
            <Title level={2} style={{ color: '#2c3e50', borderBottom: '2px solid #4a90e2', paddingBottom: 12 }}>🔧 Common Issues</Title>
            <List
                dataSource={sortedIssues}
                renderItem={(issue, index) => (
                    <List.Item>
                        <Card
                            title={<Title level={4} style={{ marginBottom: 0, whiteSpace: 'normal', paddingTop: '10px', paddingBottom: '10px' }}>{`${index + 1}. ${issue.title}`}</Title>}
                            bordered={true}
                            style={{ borderRadius: 8, width: '100%' }}
                        >
                            <p><strong>🩺 Symptoms:</strong> {issue.symptoms}</p>
                            <p><strong>🛠️ Causes:</strong> {issue.causes}</p>
                            <p style={{ background: '#f0f2f5', padding: '8px', borderRadius: '4px' }}><strong>💰 Repair Cost:</strong> {issue.repair_cost}</p>
                        </Card>
                    </List.Item>
                )}
            />
        </Card>
    );
};
